// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.islandBack {
  padding-bottom: 27px;
}
.islandBack--t {
  padding-top: 27px;
}

/* Island counts as a chunk */
.island {
  /* width: 980px; */
  margin: 0 auto;
  box-shadow: 0 1px 3px rgba(0,0,0,0.3);
  background: #fff;
  background: var(--island-background);
  /* margin-bottom: 18px;
  border: 1px solid \$s-color-neutral5; */
  border-radius: 3px;
}
.island--simplePad {
  padding: 16px 18px;
}
.island--simplePadTB {
  padding-top: 18px;
  padding-bottom: 18px;
}
.island--fluid {
  width: auto;
}

/* For if the content is too simple to warrant a complicated pad */
.island__paddedContent {
  padding: 16px 18px;
}

  .island__header {
    /* background-color: \$s-color-neutral8; */
    background-color: var(--island__header-background-color);
    /* border-bottom: 1px solid \$s-color-neutral7; */
    border-radius: 3px 3px 0 0;

    padding: 11px 18px 9px 18px;
    /* font-size: \$s-scale-3; */
  }

  .island__separator {
    /* border-top: 1px solid \$s-color-neutral7; */
    width: 100%;
  }

  .island__sub {
    display: flex;
    padding: 0 9px;
    justify-content: space-between;
  }
    .island__sub__division {
      margin: 0 9px;
      flex: 1 0;
      /* width: 0; // no-flex */
    }
      .island__sub__division__title {
        /* font-size: \$s-scale-3; */
        margin-bottom: 14px;
        margin-top: 14px;
        font-weight: 400;
        text-align: center;
      }

      .island__sub__division__title--left {
        text-align: left;
      }
  .island--pb {
    padding-bottom: 36px;
  }

`, "",{"version":3,"sources":["webpack://./pages/StellarSpaceNews/Island.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,oCAAoC;EACpC;wCACsC;EACtC,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;AACpB;;EAEE;IACE,yCAAyC;IACzC,wDAAwD;IACxD,gDAAgD;IAChD,0BAA0B;;IAE1B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,6CAA6C;IAC7C,WAAW;EACb;;EAEA;IACE,aAAa;IACb,cAAc;IACd,8BAA8B;EAChC;IACE;MACE,aAAa;MACb,SAAS;MACT,yBAAyB;IAC3B;MACE;QACE,2BAA2B;QAC3B,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;MACpB;;MAEA;QACE,gBAAgB;MAClB;EACJ;IACE,oBAAoB;EACtB","sourcesContent":[".islandBack {\n  padding-bottom: 27px;\n}\n.islandBack--t {\n  padding-top: 27px;\n}\n\n/* Island counts as a chunk */\n.island {\n  /* width: 980px; */\n  margin: 0 auto;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.3);\n  background: #fff;\n  background: var(--island-background);\n  /* margin-bottom: 18px;\n  border: 1px solid $s-color-neutral5; */\n  border-radius: 3px;\n}\n.island--simplePad {\n  padding: 16px 18px;\n}\n.island--simplePadTB {\n  padding-top: 18px;\n  padding-bottom: 18px;\n}\n.island--fluid {\n  width: auto;\n}\n\n/* For if the content is too simple to warrant a complicated pad */\n.island__paddedContent {\n  padding: 16px 18px;\n}\n\n  .island__header {\n    /* background-color: $s-color-neutral8; */\n    background-color: var(--island__header-background-color);\n    /* border-bottom: 1px solid $s-color-neutral7; */\n    border-radius: 3px 3px 0 0;\n\n    padding: 11px 18px 9px 18px;\n    /* font-size: $s-scale-3; */\n  }\n\n  .island__separator {\n    /* border-top: 1px solid $s-color-neutral7; */\n    width: 100%;\n  }\n\n  .island__sub {\n    display: flex;\n    padding: 0 9px;\n    justify-content: space-between;\n  }\n    .island__sub__division {\n      margin: 0 9px;\n      flex: 1 0;\n      /* width: 0; // no-flex */\n    }\n      .island__sub__division__title {\n        /* font-size: $s-scale-3; */\n        margin-bottom: 14px;\n        margin-top: 14px;\n        font-weight: 400;\n        text-align: center;\n      }\n\n      .island__sub__division__title--left {\n        text-align: left;\n      }\n  .island--pb {\n    padding-bottom: 36px;\n  }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
